import React from 'react';
import { useLocation } from 'react-router-dom';
import RegistroForm from '../components/RegistroForm';
import { Container } from '@mui/material';

const RegistroPage = () => {
  const location = useLocation();
  const  {customer} = location.state || {};

  return (
    <Container maxWidth="lg">
      <RegistroForm customer={customer} />
    </Container>
  );
};

export default RegistroPage;